import type { CanvasMode } from "@aquaduck/shared";

export interface WorkspaceRoute {
  tab: CanvasMode;
  /** A chat root or reply; the owning Chat opens its containing thread. */
  msg?: string;
  obj?: string;
  view?: "oneup" | "grid";
  /** Only grid-origin one-up links opt into returning to the grid. */
  from?: "grid";
  /** Preserves an exact Present block, including highlight links. */
  present?: string;
}
export function parseRoute(hash: string): WorkspaceRoute {
  const legacy = /^#(obj|present):(.+)$/.exec(hash);
  if (legacy) {
    let id: string;
    try { id = decodeURIComponent(legacy[2]!); } catch { return { tab: "collaborate" }; }
    return legacy[1] === "obj" ? { tab: "collaborate", obj: id } : { tab: "present", present: id };
  }
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  const tab = params.get("tab");
  const obj = params.get("obj") || undefined;
  return {
    // Retired `tab=dev` links (and anything unknown) land on collaborate.
    tab: tab === "preview" || tab === "present" ? "present" : "collaborate",
    ...(obj ? { obj } : {}),
    ...(params.get("msg") ? { msg: params.get("msg")! } : {}),
    ...(obj && params.get("view") === "oneup" ? { view: "oneup" as const } : {}),
    ...(params.get("view") === "grid" && (!tab || tab === "collaborate") ? { view: "grid" as const } : {}),
    ...(obj && params.get("view") === "oneup" && params.get("from") === "grid" ? { from: "grid" as const } : {}),
    ...(params.get("present") ? { present: params.get("present")! } : {}),
  };
}
export function serializeRoute(route: WorkspaceRoute): string {
  const params = new URLSearchParams({ tab: route.tab === "present" ? "preview" : route.tab });
  if (route.msg) params.set("msg", route.msg);
  if (route.obj) params.set("obj", route.obj);
  if (route.obj && route.view === "oneup") params.set("view", "oneup");
  if (route.view === "grid" && route.tab === "collaborate") params.set("view", "grid");
  if (route.obj && route.view === "oneup" && route.from === "grid") params.set("from", "grid");
  if (route.present) params.set("present", route.present);
  return `#${params}`;
}

/** The share page uses the same bundle, outside the editing shell. */
export function isPreviewPage(pathname: string): boolean {
  return pathname === "/preview" || pathname === "/preview/";
}
